import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

//const UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

const SidebarContent = props => {
  const ref = useRef()
  const navigate = useNavigate()

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function tToggle() {
    //To close and open sidebar
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } //else {
    //   body.classList.toggle("vertical-collpsed")
    //   body.classList.toggle("sidebar-enable")
    // }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          {/* See SidebarContent.js — mt-5 was compensating for the old
              unreserved logo height and is no longer needed. */}
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/super/admin/dashboard" onClick={tToggle}>
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Users")}</span>
              </Link>
            </li>
            <li>
              <Link to="/super/admin/nda-agreement" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("NDA Agreement")}</span>
              </Link>
            </li>
            <li>
              <Link to="/super/admin/manage-lob" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Manage LOB")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/manage-sub-lob" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Manage SubLOB")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/insurance-company" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Insurance Company")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/manage-incomerange" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Manage Income Range")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/vehicle-master" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Manage Vehicle Master")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/manage-rto" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Manage RTO")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/knowledge-center" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Manage Knowledge Center")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/marketing-tools" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Marketing Tools")}</span>
              </Link>
            </li>

            <li>
              <Link to="/super/admin/whatsappmsg" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("WhatsApp Message")}</span>
              </Link>
            </li>


            <li>
              <Link to="/super/admin/query-file" onClick={tToggle}>
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Upload Query File")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
